<template>
  <div>
    <b-modal
      size="lg"
      id="add-gateway-modal"
      title="ایجاد درگاه پرداخت"
      cancel-title="انصراف"
      ok-title="ذخیره"
      ref="refaddgatewaymodal"
      @ok.prevent="savePaymentGateway(0)"
    >
      <b-modal
        id="modal-f"
        title="خطا در کد رهگیری اقتصادی"
        cancel-title="انصراف"
        ok-title="موافقم"
        @ok.prevent="savePaymentGateway(1)"
      >
        <p class="my-4">
          این کد رهگیری مالیاتی پیش از این توسط شما برای درگاه دیگری منظور گشته
          است. لطفا قوانین و مقررات مالیاتی مربوط به دریافت درگاه ها را مطالعه
          بفرمایید و در صورت تایید درخواست خود را ثبت نمایید
        </p>
      </b-modal>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <form ref="newgateform">
        <div>
          <b-row>
            <div class="col-md-4">
              <b-form-group label="لوگو">
                <fileUploader
                  ref="upload_logo"
                  v-model="newgate.logo"
                ></fileUploader>
              </b-form-group>
              <b-img
                v-if="newgate.logo != null"
                :src="'http://api.shepa.com/api/file/' + newgate.logo"
                fluid
              ></b-img>
            </div>
            <div class="col-md-8">
              <b-form-group label="نام وب سایت" label-for="input_website_name">
                <b-form-input
                  id="input_website_name"
                  aria-describedby="input_website_name_describe"
                  placeholder="نام وب سایت"
                  required
                  v-model="$v.newgate.websiteName.$model"
                  :state="validateState('websiteName')"
                ></b-form-input>
                <b-form-invalid-feedback id="input_website_name_describe"
                  >نام وبسایت را وارد کنید</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label="نام انگلیسی وب سایت"
                label-for="input_website_en_name"
              >
                <b-form-input
                  id="input_website_en_name"
                  aria-describedby="input_website_en_name_describe"
                  placeholder="نام انگلیسی وب سایت"
                  required
                  v-model="$v.newgate.website_en_name.$model"
                  :state="validateState('website_en_name')"
                ></b-form-input>
                <b-form-invalid-feedback id="input_website_en_name_describe"
                  >نام انگلیسی وبسایت را وارد کنید</b-form-invalid-feedback
                >
              </b-form-group>
              <b-form-group
                label="آدرس وب سایت"
                label-for="input_website_address"
              >
                <b-form-input
                  id="input_website_address"
                  aria-describedby="input_website_address_describe"
                  placeholder="آدرس وب سایت"
                  required
                  v-model="$v.newgate.websiteAddress.$model"
                  :state="validateState('websiteAddress')"
                ></b-form-input>
                <b-form-invalid-feedback id="input_website_address_describe"
                  >آدرس وبسایت را به صورت صحیح وارد کنید
                  [مثال:http(s)://example.com]</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
          </b-row>
          <b-form-group label="توضیحات" label-for="input_website_description">
            <b-textarea
              id="input_website_description"
              placeholder="توضیحات"
              required
              v-model="newgate.description"
            ></b-textarea>
          </b-form-group>
          <b-row>
            <div class="col-md-4">
              <b-form-group
                label="شماره تماس پشتیبانی"
                label-for="input_support_phone"
              >
                <b-row>
                  <b-col>
                    <b-form-input
                      id="input_support_phone"
                      placeholder="تلفن"
                      v-model="$v.newgate.supportPhone.$model"
                      :state="validateState('supportPhone')"
                      aria-describedby="input_support_phone_describe"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input_support_phone_describe"
                  >تلفن پشتیبانی را وارد کنید</b-form-invalid-feedback
                >
                  </b-col>
                  <b-col cols="5">
                    <b-form-input
                      id="input_support_phone"
                      placeholder="کد شهر"
                      v-model="$v.newgate.pre_phone.$model"
                      :state="validateState('pre_phone')"
                      aria-describedby="input_support_phone_describe"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input_support_phone_describe"
                  >کد تلفن را وارد کنید</b-form-invalid-feedback
                >
                  </b-col>
                </b-row>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="دسته بندی" label-for="select_category">
                <MDDropdown
                  id="select_category"
                  placeholder="دسته بندی"
                  group="9"
                  required
                  :class="[
                    $v.newgate.category.$error
                      ? 'is-invalid vs-select-search'
                      : '',
                    !$v.newgate.category.$error && $v.newgate.category.$model
                      ? 'is-valid vs-select-search'
                      : '',
                  ]"
                  v-model="$v.newgate.category.$model"
                  :state="validateState('category')"
                  aria-describedby="input_category_describe"
                ></MDDropdown>
                <b-form-invalid-feedback id="input_category_describe"
                  >دسته بندی را انتخاب کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="نوع کارمزد" label-for="select_Commission">
                 <b-form-select id="select_Commission"
                  placeholder="نوع کارمزد"
                  group="2"
                  text=""
                  required
                  :class="[
                    $v.newgate.purcent_from_merchant.$error
                      ? 'is-invalid vs-select-search'
                      : '',
                    !$v.newgate.purcent_from_merchant.$error && $v.newgate.purcent_from_merchant.$model
                      ? 'is-valid vs-select-search'
                      : '',
                  ]"
                  :options="commisionOptions"
                  v-model="$v.newgate.purcent_from_merchant.$model"
                  :state="validateState('purcent_from_merchant')"
                  aria-describedby="input_category_Commission">
                 </b-form-select>
                <b-form-invalid-feedback id="input_category_Commission"
                  >نوع کارمزد را انتخاب کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group label="نحوه واریز مبلغ">
                <MDDropdown
                  v-bind:group="104"
                  v-model="$v.newgate.mdid104_payment_priority.$model"
                  :state="validateState('mdid104_payment_priority')"
                  aria-describedby="input_mdid104_payment_priority_describe"
                ></MDDropdown>
                <b-form-invalid-feedback
                  id="input_mdid104_payment_priority_describe"
                  >نحوه واریز مبلغ را انتخاب کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div
              class="col-md-4"
            >
              <b-form-group
                label="کد رهگیری مالیاتی"
                label-for="input_taxpayercode"
              >
                <b-form-input
                  id="input_taxpayercode"
                  placeholder="کد رهگیری مالیاتی"
                  v-model="newgate.taxpayercode"
                  :state="validateState('taxpayercode')"
                  aria-describedby="input_taxpayercode"
                ></b-form-input>
                <b-form-invalid-feedback id="input_taxpayercode"
                  >کد رهگیری مالیاتی را وارد کنید</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="col-md-8">
              <b-form-group
              id="shepalink"
              label="شماره شبای بانکی:"
              label-for="shepalink-input-1"
            >
              <b-input-group class="mt-3">
                <!-- <template v-slot:append> -->

                <!-- </template> -->
                <b-form-select
                  :options="userCards"
                  v-model="$v.newgate.card.$model"
                  :class="$v.newgate.card.$error ? 'is-invalid' : ''"
                  :state="validateState('card')"
                  id="select_banking_card"
                ></b-form-select>
                <b-button
                    variant="success"
                    class="rounded-left-0"
                    @click="$bvModal.show('addcard-modal')"
                    >جدید</b-button
                  >
                <b-form-invalid-feedback id="input_card_describe"
                  >حساب بانکی را انتخاب کنید</b-form-invalid-feedback
                >
              
              </b-input-group>
            </b-form-group>
            </div>
            
            <div
              class="col-md-4"
              v-if="newgate.mdid104_payment_priority != 1658"
            >
              <b-form-group label="در روز">
                <MDDropdown
                  v-bind:group="105"
                  v-model="newgate.mdid105_payment_time"
                  v-bind:parent="newgate.mdid104_payment_priority"
                ></MDDropdown>
              </b-form-group>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                id="checkbox-1"
                v-model="accepted_rule"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                <b-link
                  :href="inrules"
                  target="_blank"
                  >قوانین و مقررات </b-link
                >را خوانده ام و می پذیرم
                <div
                  style="direction: rtl"
                  v-if="text_accepted"
                  class="text-danger mt-3"
                >
                  لطفا قوانین و مقررات را تایید نمایید
                </div>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr />
            </b-col>
          </b-row>
        </div>
      </form>
    </b-modal>
    <AddCard v-bind:afterdone="getaccounts"></AddCard>
  </div>
</template>

<style>
.custom-select.is-valid,
.was-validated .custom-select:valid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath fill='%231BC5BD' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}
.is-invalid.vs-select-search {
  border: 1px solid red;
  border-radius: 6px !important;
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}

.is-valid.vs-select-search {
  border: 1px solid #0d7d65;
  border-radius: 6px !important;
}
.custom-select.is-invalid,
.was-validated .custom-select:invalid {
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%231B283F' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat left 1rem center/8px 10px,
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23F64E60'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23F64E60' stroke='none'/%3E%3C/svg%3E")
      #fff no-repeat center left 2rem / calc(0.75em + 0.65rem)
      calc(0.75em + 0.65rem);
}

.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
.shadow-lg {
  -webkit-box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.3) !important;
  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.3) !important;
}
.form-control.is-invalid, .was-validated .form-control:invalid {
  padding-right: calc(1.5em + 1.3rem);
}
.form-control.is-valid, .was-validated .form-control:valid {
  padding-right: calc(1.5em + 1.3rem);
}
/* .custom-select.is-valid, .was-validated .custom-select:valid{
  padding-right: calc(1.5em + 1.3rem);
} */
</style>

<script>
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  minLength,
  maxLength,
  url,
  requiredIf,
} from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import FileUploader from "@/components/fileUploader";
import AddCard from "../BankCards/AddCard";
import httpHelper from "../../helpers/httpHelper";

const enchars = (value, vm) => !/[^A-Za-z0-9]/.test(value);
//const numbers = (value, vm) => !/[^0-9]/.test(value);
const numbers = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]*$/.test(value);
const fachars = (value, vm) => /[^A-Za-z0-9]/.test(value);
//const phone = (value, vm) => /\d{5,8}/g.test(value);
const phone = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{5,8}$/.test(value);
//const prephone = (value, vm) => /0\d{2}/.test(value);
const prephone = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{3}$/.test(value);
//const mobile = (value, vm) => !/^09{9}/g.test(value);
const mobile = (value, vm) => /^[\u06F0-\u06F9\s||z0-9]{11}$/.test(value);
const shepaUrl = (value, vm) =>
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(
    value
  );
export default {
  mixins: [validationMixin],
  props: ["afterdone", "moneyType"],
  name: "addGateway",
  data() {
    return {
      inrules: "https://shepa.com/shepa_rules/",
      outrules: "https://shepa.com/shepa_international_rules/",
      commisionOptions: [
          { value: 0, text: 'کسر از پرداخت کننده' },
          { value: 1, text: 'کسر از پذیرنده' }
        ],
      newgate: {
        websiteName: "",
        website_en_name: "",
        websiteAddress: "",
        supportPhone: "",
        category: null,
        moneyType: null,
        card: null,
        purcent_from_merchant: null,
        // gatewayType: 701,
        mdid104_payment_priority: 1658,
        mdid105_payment_time: 1661,
        logo: "dd9a5321-f7fd-4087-b514-6856c9c20798",
        pre_phone: "",
        taxpayercode: null,
        wallet: null,
        // purcent_from_merchant: null,
        // mdid14_direct_gate: null,
        is_direct:null,
      },
      all_wallets: [],
      userCards: [],
      errors: [],
      accepted_rule: "not_accepted",
      // accepted_tax: "not_accepted",
      text_accepted: false,
      text_accepted_tax: false,
      purcentOptions:[
          { value: 0, text: "کسر از کاربر" },
          { value: 1, text: "کسر از پذیرنده" },
      ],
      optionsConnect:[{text:'مستقیم',value:701},{text:'واسط',value:-1},{text:'شپا لینک',value:1673}],
      // show_is_direct:false,
    };
  },
  validations: {
    newgate: {
      // mdid14_direct_gate:{
      //   // required
      // },
      websiteName: {
        required,
        fachars,
        minLength: minLength(3),
      },
      website_en_name: {
        required,
        minLength: minLength(3),
        enchars,
      },
      websiteAddress: {
        required,
        url,
        minLength: minLength(3),
      },
      description: {
        minLength: minLength(3),
      },
      supportPhone: { required, minLength: minLength(5), phone },
      category: {
        required,
      },
      purcent_from_merchant: {
        required,
      },
      card: {
        required,
      },
      moneyType: {
        required,
      },
      mdid104_payment_priority: {
        required,
      },
      taxpayercode: {
        required,
      },
      pre_phone: { required, prephone },

    },
  },
 
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.newgate[name];
      return $dirty ? !$error : null;
    },
    onchange(e){
      e==1673 ? this.is_direct=0 : e==701 ? this.is_direct=1 : this.is_direct=0;

    },
    savePaymentGateway(ignore_repeat_taxpayercode) {
      this.$v.newgate.$touch();
      if (this.$v.newgate.$anyError) {
        
        // console.log("hi",this.$v.newgate);
        if (this.newgate.moneyType != 483 && this.newgate.moneyType != 484) {
        }
        return;
      }
      if (this.accepted_rule == "not_accepted") {
        this.text_accepted = true;
        return;
      } else {
        this.text_accepted = false;
      }

      // if (this.newgate.moneyType == 483 || this.newgate.moneyType == 484) {
      //   if (this.accepted_tax == "not_accepted") {
      //     this.text_accepted_tax = true;
      //     return;
      //   } else {
      //     this.text_accepted_tax = false;
      //   }
      // }

      if (ignore_repeat_taxpayercode == 1) {
        this.$bvModal.hide("modal-f");
      }
      this.sendCreateGatewayRequest(ignore_repeat_taxpayercode);
    },
    sendCreateGatewayRequest: function (ignore_repeat_taxpayercode) {
     
      this.errors = [];
      let newGatewayData = {
        website_name: this.newgate.websiteName,
        website_en_name: this.newgate.website_en_name,
        website: this.newgate.websiteAddress,
        mdid12_money_type: this.newgate.moneyType,
        // mdid14_direct_gate: this.newgate.mdid14_direct_gate == -1 ? 701 : this.newgate.mdid14_direct_gate,
        mdid14_direct_gate: 701,
        mdid9_category: this.newgate.category,
        description: this.newgate.description,
        phone_support: this.newgate.supportPhone,
        logo: this.newgate.logo,
        mdid104_payment_priority: this.newgate.mdid104_payment_priority,
        mdid105_payment_time: this.newgate.mdid105_payment_time,
        pre_phone: this.newgate.pre_phone,
        taxpayercode: this.newgate.taxpayercode,
        ignore_repeat_taxpayercode: ignore_repeat_taxpayercode,
        // purcent_from_merchant: this.newgate.purcent_from_merchant,
        purcent_from_merchant: 1,
        is_direct: this.is_direct
        };
      if (this.newgate.moneyType != 483 && this.newgate.moneyType != 484) {
        newGatewayData.mdid14_direct_gate = 702;
      }
      if (newGatewayData.mdid14_direct_gate == 701)
        newGatewayData.user_card_id = this.newgate.card;
      if (newGatewayData.mdid14_direct_gate == 702) {
        newGatewayData.wallet_id = this.newgate.wallet;
        newGatewayData.user_card_id = this.newgate.card;
      }

      httpHelper
        .postData("paymentgateways", newGatewayData)
        .then((response) => {
          if (response.success === true) {
            this.$bvModal.hide("add-gateway-modal");
            this.$makeToast("success", "درگاه جدید", "درگاه با موفقیت ثبت شد.", 7000);
            this.afterdone();
            if (this.afterdone != null) {
            }
          } else if (response.errorCode == 624) {
            this.$bvModal.show("modal-f");
          } else {
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.errors.push(element);
              });
            }
          }
        });
    },
    getWallets() {
      httpHelper.getData("wallets").then((res) => {
        this.all_wallets = res.result
          .filter((o) => {
            return o.mdid12_money_type == this.moneyType;
          })
          .map((element) => {
            return {
              value: element.id,
              text: element.wallet_name,
            };
          });
      });
    },
    // ShowDropdownIsDirect(e){
    //   e===701 ? this.show_is_direct=true : this.show_is_direct=false;
    // },
    getaccounts() {
      //   this.step5.shepalink = this.user.mobile;
      httpHelper.getData("usercards").then((response) => {
      this.userCards = response.result
        .filter(function (o) {
          return o.is_business_partners == 0;
        })
        .map((item) => {
          return {
            text: item.shaba_number + "(" + item.nickname + ")",
            value: item.id,
          };
        });
    });
    },
  },
  components: {
    FileUploader,
    MDDropdown,
    AddCard
  },
  mounted() {
    var self = this;

    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      
      if (modalId == "add-gateway-modal") {
        this.getWallets();
        this.newgate = {
          websiteName: "",
          website_en_name: "",
          websiteAddress: "",
          supportPhone: "",
          category: null,
          purcent_from_merchant: null,
          moneyType: this.moneyType != null ? 1722 : 483,
          card: null,
          // gatewayType: 701,
          mdid104_payment_priority: 1658,
          mdid105_payment_time: 1661,
          logo: "1490e320-928d-4986-a013-91f7832db455",
          pre_phone: "",
          taxpayercode: null,
          wallet: null,
          purcent_from_merchant: null,
          mdid14_direct_gate:null
        };
        //self.$v.$reset();
      }
    });
   this.getaccounts();
  },
};
</script>
